/**
 * PRIVATE-invalid-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { MessageTag } from "../message-tag";
import { Message } from "./message";

/**
 * A malformed or incorrect {@link Message}.
 */
export class InvalidMessage extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.PVT_INVALID;

  public timestamp : number = Date.now();

  public expectsReply () : boolean
  {
    return false;
  }

  public sendable () : boolean
  {
    return false;
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/general/PRIVATE-invalid-message.ts